import Swiper from "swiper";
import {debounce} from "../../helpers";

export const initWishesSlider = () => {
  let sliders = document.querySelectorAll('.wp-block-wishes .wishes-slider')

  if (sliders[0]) {
    sliders.forEach(slider => {
      let swiper = null
      let sliderWrapper = slider.querySelector('ul');
      let sliderWrapperClassList = sliderWrapper.classList.value;
      let slides = slider.querySelectorAll('li');

      function awaitingWishesSlider() {
        if (window.innerWidth < 1024) {
          slider.classList.add('swiper')
          sliderWrapper.removeAttribute('class');
          sliderWrapper.classList.add('swiper-wrapper')

          slides.forEach(slide => {
            slide.classList.add('swiper-slide');
          });

          swiper = new Swiper(slider, {
            spaceBetween: 15,
            loop: false,
            slidesPerView: 1.25,
            breakpoints: {
              470: {
                slidesPerView: 1.5
              },
              576: {
                slidesPerView: 1.7
              },
              768: {
                slidesPerView: 2.5
              }
            }
          })
        } else {
          slider.classList.remove('swiper')
          sliderWrapper.removeAttribute('class');
          sliderWrapper.setAttribute('class', sliderWrapperClassList);


          if (swiper !== null) {
            swiper.destroy(true, true)
          }
        }
      }

      awaitingWishesSlider()

      window.addEventListener('resize', debounce(awaitingWishesSlider, 500))
    })
  }
}
